import { SelectionNamePieces } from './internal';
export class SelectionNamePhonetization extends SelectionNamePieces {
    getMethod() {
        return this.get("TYPE" /* Tag.Type */);
    }
}
//# sourceMappingURL=SelectionNamePhonetization.js.map